import clsx from "clsx";

import { TertiaryButton } from "@shared/buttons";

import { OPERATOR_ICON_LIST } from "../consts";
import { useFormulaBuilder } from "../hooks/use-formula-builder";

interface Props {
  isDisabled?: boolean;
}

export const OperatorSelection = ({ isDisabled }: Props) => {
  const { addOperator } = useFormulaBuilder();

  return (
    <div className="p-4 border border-b-gray-2 border-x-0 border-t-0">
      <div className="text-gray+2 text-xs font-medium tracking-wider mb-2">
        INSERT OPERATORS
      </div>
      <div className="flex items-center space-x-1">
        {OPERATOR_ICON_LIST.map(({ icon, value }) => (
          <TertiaryButton
            key={value}
            className={clsx(
              "border flex items-center justify-center h-6 w-11 rounded-full bg-cosmic-5",
              {
                "border-cosmic hover:bg-cosmic-4 hover:text-cosmic+1 cursor-pointer":
                  !isDisabled,
                "border-gray-1": isDisabled,
              },
            )}
            disabled={isDisabled}
            onClick={() => addOperator(value)}
          >
            <i className={clsx("fa-regular", `fa-${icon}`)} />
          </TertiaryButton>
        ))}
      </div>
    </div>
  );
};
